import { render, staticRenderFns } from "./lp-invest-registration-4.vue?vue&type=template&id=86455d06&scoped=true"
import script from "./lp-invest-registration-4.vue?vue&type=script&lang=js"
export * from "./lp-invest-registration-4.vue?vue&type=script&lang=js"
import style0 from "./lp-invest-registration-4.vue?vue&type=style&index=0&id=86455d06&prod&scoped=true&lang=css"
import style1 from "./lp-invest-registration-4.vue?vue&type=style&index=1&id=86455d06&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86455d06",
  null
  
)

export default component.exports